import React, { useState } from "react";
import "./TokenGenerator.css";

function TokenGenerator() {
  const [theme, setTheme] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [error, setError] = useState("");

  const generateToken = async () => {
    setError("");
    setTokenData(null);

    try {
      const response = await fetch(
        "https://wackywhiskers.site/generate_token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ theme }),
        }
      );

      const data = await response.json();
      if (data.success) {
        setTokenData(data.token_data);
      } else {
        setError(data.error);
      }
    } catch (error) {
      setError("Failed to connect to the server.");
    }
  };

  return (
    <div className="token-generator">
      <h1>AI Meme Token Generator</h1>
      <input
        type="text"
        placeholder="Enter a theme (e.g., funny)"
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
      />
      <button onClick={generateToken}>Generate Token</button>

      {error && <div className="error">Error: {error}</div>}

      {tokenData && (
        <div className="token-data">
          <p>
            <strong>Token Name:</strong> {tokenData.name}
          </p>
          <p>
            <strong>Ticker:</strong> {tokenData.ticker}
          </p>
          <p>
            <strong>Description:</strong> {tokenData.description}
          </p>
          <img
            className="token-image"
            src="https://via.placeholder.com/300"
            alt="Generated token"
          />
        </div>
      )}
    </div>
  );
}

export default TokenGenerator;
